export default function productLiveViewers() {
  return {
    count: 0,

    init() {
      const min = parseInt(this.$el.dataset.min ?? '4');
      const max = parseInt(this.$el.dataset.max ?? '14');

      this.count = Math.floor(Math.random() * (max - min + 1)) + min;

      const tick = () => {
        const delta = Math.random() < 0.5 ? 1 : -1;
        const next = this.count + delta;
        if (next >= min && next <= max) this.count = next;
        setTimeout(tick, Math.floor(Math.random() * 8000) + 4000);
      };

      setTimeout(tick, Math.floor(Math.random() * 8000) + 4000);
    },
  };
}
